module.exports = __webpack_public_path__ + "img/logo_tailoc.46c63af4.png";